export const PostMessageContractorUpdated = {
  type: 'USER_CONTRACTOR_UPDATED',
} as const;
